import {GTMEvent, propertyConfiguratorAnalytics} from "../analytics/events";
import {PropertyConfiguratorStep} from "../views/PropertyConfigurator";

export const usePropertyConfiguratorStepAnalytics = () => {
    return (step: PropertyConfiguratorStep) => {
        if (window.dataLayer) {
            const stepChangeAlreadyTracked = window.dataLayer.some((item: {event?: string; config_step?: PropertyConfiguratorStep}) => {
                return !!item.event && item.event === GTMEvent.FLAT_CONFIG && !!item.config_step && item.config_step === step;
            });

            if (!stepChangeAlreadyTracked) {
                propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(GTMEvent.FLAT_CONFIG, {config_step: step});
            }
        }
    };
};
import {GTMEvent, propertyConfiguratorAnalytics} from "../analytics/events";
import {PropertyConfiguratorStep} from "../views/PropertyConfigurator";

export const usePropertyConfiguratorStepAnalytics = () => {
    return (step: PropertyConfiguratorStep) => {
        if (window.dataLayer) {
            const stepChangeAlreadyTracked = window.dataLayer.some((item: {event?: string; config_step?: PropertyConfiguratorStep}) => {
                return !!item.event && item.event === GTMEvent.FLAT_CONFIG && !!item.config_step && item.config_step === step;
            });

            if (!stepChangeAlreadyTracked) {
                propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(GTMEvent.FLAT_CONFIG, {config_step: step});
            }
        }
    };
};
